module.exports = __webpack_public_path__ + "static/media/Jedediahs-banner-logo.8fc5ba09.png";